<template>
	<!-- 派单管理 -->
	<div class="billOperationRecord public_Spacing">
		<div class="pulbic_oparetionBlock" style="margin-bottom: 12px;">
			<div class="public_criteriaRange">

				<div class="public_oparetionBlock_Menu" v-if="this.uobj.pertb005.pertb005cb00 =='CUS-1'">
					<label class="public_lbSty">加油站：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="ORMTB474CA00" placeholder="请选择"
							   filterable>
						<el-option v-for="item in oilList" :key="item.ORMTB473ID" :label="item.ORMTB473CA00"
								   :value="item.ORMTB473ID">
						</el-option>
					</el-select>
				</div>

				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">核销人：</label>
					<div class="el-select public_optionSty">
						<div class="el-input el-input--suffix">
							<input class="pulic_carNumber" type="text" placeholder="请输入" v-model="ORMTB474CA02" />
						</div>
					</div>
				</div>
				<!-- <div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">核销人电话：</label>
					<div class="el-select public_optionSty">
						<div class="el-input el-input--suffix">
							<input class="pulic_carNumber" type="text" placeholder="请输入" v-model="ORMTB474CA03" />
						</div>
					</div>
				</div> -->

				<!-- <div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">司机姓名：</label>
					<div class="el-select public_optionSty">
						<div class="el-input el-input--suffix">
							<input class="pulic_carNumber" type="text" placeholder="请输入" v-model="ORMTB474CA05" />
						</div>
					</div>
				</div>
				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">司机电话：</label>
					<div class="el-select public_optionSty">
						<div class="el-input el-input--suffix">
							<input class="pulic_carNumber" type="text" placeholder="请输入" v-model="ORMTB474CA06" />
						</div>
					</div>
				</div> -->
				<!--<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">时间：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="timeType" placeholder="请选择">
						<el-option label="派单时间" value="1">
						</el-option>
						<el-option label="结算时间" value="2">
						</el-option>
					</el-select>
				</div>-->
				<!-- <div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">收支类型：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="ORMTB474CA11" placeholder="请选择">
						<el-option v-for="item in orOptions" :key="item.value" :label="item.label"
								   :value="item.value">
						</el-option>
					</el-select>
				</div> -->

			</div>
			<div class="public_operatArea">
				<span class="pulic_operatArea_now pulic_cursor" :class="dateNowDayActive?'public_dateActive':''"
					  @click="getNowDay">当日</span>
				<span class="public_operatArea_yesterday pulic_cursor"
					  :class="dateYesterdayActive?'public_dateActive':''" @click="getYesterday">昨天</span>
				<span class="pulic_operatArea_now pulic_cursor" :class="dateNowMonthActive?'public_dateActive':''"
					  @click="sameMonth">当月</span>
				<span class="public_operatArea_yesterday pulic_cursor"
					  :class="dateLastMonthActive?'public_dateActive':''" @click="lastMonth">上月</span>
				<div class="public_operatArea_timePicker pulic_cursor">
					<el-date-picker v-model="date" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
									range-separator="至" :picker-options="startDateDisabled" @change="datePickerChange"
									start-placeholder="开始日" end-placeholder="结束日" class="pulic_cursor">
					</el-date-picker>
				</div>
				<div class="public_operatBtn">
					<button @click="queryClick" class="public_saleWater_chaxun pulic_cursor"
							id="查询"><i class="iconfont icon-chaxun"></i>查询</button>
					<el-button class="public_saleWater_daochu pulic_cursor" :loading="loadingBut" @click="exports"
							   id="导出"><i class="iconfont icon-daochu"></i>导出<span
							v-if="confirmTxt >0">{{confirmTxt}}</span></el-button>
				</div>
			</div>
		</div>
		<div id="统计" style="width: 100%;">
			<div class="pulbic_oparetionBlock public_statisticsInfo">
				<div class="public_statistics billDetails-statistics">
					<div class="public_statisticsContent">
						<img class="imgStatistics" src="../../assets/images/orderStatistics/trainNumber.png">
						<!-- <i style="color: #FF9E4F!important;font-size: 20px;" class="iconfont icon-chongzhi1"></i> -->
						<div class="payType">单数</div>
					</div>
					<ul class="billDetails-ul">
						<!-- <li class="pulic_statistics_titlt"><span class="totolTitle">收入车次(单)</span><span class="Amount"
																										style="color: #199FFF;">{{incount}}</span></li> -->
						<li class="pulic_statistics_titlt"><span class="totolTitle">核销单数(单)</span><span
								class="singular">{{expcount}}</span></li>
					</ul>
				</div>

				<div class="public_statistics billDetails-statistics">
					<div class="public_statisticsContent">
						<img class="imgStatistics" src="../../assets/images/orderStatistics/money.png">
						<div class="payType">金额</div>
					</div>
					<ul class="billDetails-ul">
						<!-- <li class="pulic_statistics_titlt"><span class="totolTitle">收入金额(元)</span><span class="Amount"
																										style="color: #08D691;">{{inprice}}</span></li> -->
						<li class="pulic_statistics_titlt"><span class="totolTitle">核销金额(元)</span><span
								class="singular">{{expprice}}</span></li>
					</ul>
				</div>
				<!-- <div class="public_statistics billDetails-statistics">
					<div class="public_statisticsContent">
						<img class="imgStatistics" src="../../assets/images/orderStatistics/weight.png">
						<div class="payType">核销量</div>
					</div>
					<ul class="billDetails-ul">
						<li class="pulic_statistics_titlt"><span class="totolTitle">核销油量(升)</span><span class="Amount"
																										style="color: #FF4500;">{{expcap}}</span></li>

					</ul>
				</div> -->

			</div>
		</div>
		<div class="billOperationRecord-table pulbic_table_container">
			<el-table tooltip-effect="dark" :data="tableData" style="width: 100%;"
					  :default-sort="{prop: 'waterNum', order: 'descending'}"
					  :header-cell-style="{color:'rgba(51,51,51,1)', background:'rgba(184,227,255,1)','font-weight':'bold'}"
					  class="public_tableColumn">
				<!--<el-table-column prop="ORMTB440CA00" width="130" fixed="left" label="派单编号">-->
				<!--</el-table-column>-->
				<el-table-column prop="ORMTB474CA00NAME" width="130" label="加油站">
				</el-table-column>

				<el-table-column v-for='(item,index) in tableHeadList' :width="item.width" :prop="item.prop"
								 :label="item.label" :key="index">
				</el-table-column>

				<!-- <el-table-column  width="100" prop="ORMTB474CA11" label="收支类型">
					<template slot-scope="scope">{{scope.row.ORMTB474CA11==1?'收入':'支出'}}</template>
				</el-table-column> -->

				<el-table-column v-if="this.uobj.pertb005.pertb005cb00 =='CUS-1'" label="操作" fixed="right" width="300">
					<template slot-scope="scope">
					<!--	<el-button class="public_icon_xiangqing public_icon_width  public_icon_margin" type="primary"
								   size="small" @click="DetailsClick(scope.row)">详情</el-button>

						<el-button class="public_icon_xiugai public_icon_width public_icon_margin"
								   v-if="(scope.row.ORMTB440CF01==0||scope.row.ORMTB440CF01==1||scope.row.ORMTB440CF01==2)&&scope.row.isauditOrder==0&&uobj.pertb005.pertb005cb00=='CUS-1'"
								   type="primary" size="small" id="取消订单" v-shiroHiden="solelist"
								   @click="cancelOrder(scope.row)">取消订单</el-button>

						<el-button class="public_icon_xiangqing public_icon_width  public_icon_margin"
								   v-if="(scope.row.ORMTB440CF01=='-2')&&scope.row.ORMTB440CG00==0&&uobj.pertb005.pertb005cb00=='CUS-1'"
								   type="primary" id="审核取消" v-shiroHiden="solelist" size="small"
								   @click="orderAudit(scope.row)">审核取消</el-button>

						<el-button class="public_icon_xiangqing public_icon_width  public_icon_margin"
								   v-if="scope.row.isauditOrder==1&&uobj.pertb005.pertb005cb00=='CUS-1'" type="primary"
								   size="small" @click="isorderAudit(scope.row)" id="审核派单" v-shiroHiden="solelist">审核派单
						</el-button>
						<el-button class="public_icon_xiangqing public_icon_width  public_icon_margin"
								   v-if="scope.row.ORMTB440CF01==4&&uobj.pertb005.pertb005cb00=='CUS-1'&&scope.row.ORMTB440CF00=='ZG'"
								   type="primary" size="small" @click="returnReceipt(scope.row)" id="确认回执"
								   v-shiroHiden="solelist">确认回执</el-button>

						<el-button class="public_icon_xiangqing public_icon_width  public_icon_margin"
								   type="primary" size="small" @click="pushMsg(scope.row)" id="推送支付消息"
								   v-if="scope.row.ORMTB440CA29==1 && scope.row.ORMTB440CA30==0 "
						>推送支付消息</el-button>

						<el-button class="public_icon_xiangqing public_icon_width  public_icon_margin"
								   type="primary" size="small" @click="completeClick(scope.row)" id="结算"
								   v-if="scope.row.ORMTB440CA29==1 && scope.row.ORMTB440CA30==0 "
						>结算</el-button>

						<el-button class="public_icon_xiangqing public_icon_width  public_icon_margin"
								   v-if="scope.row.ORMTB440CA29==1"
								   type="primary" size="small" @click="ewmDetailsClick(scope.row)" id="查看二维码"
						>查看二维码
						</el-button>



						<el-button
								v-if="scope.row.ORMTB401CA01==='ZJ'&&(scope.row.ORMTB440CF01==6 || (scope.row.ORMTB440CF01==0&&scope.row.ORMTB440CA22))"
								class="public_icon_xiugai public_icon_width public_icon_margin" type="primary" size="small"
								@click="inputWeightClick(scope.row)" id="完成订单">完成订单</el-button>
-->
					</template>
				</el-table-column>
			</el-table>
			<div class="pulbic_pagesize">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							   :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
							   layout="total,sizes, prev, pager, next, jumper" :total="pagingPageMo">
				</el-pagination>
			</div>
		</div>

	</div>
</template>

<script>
    import qs from 'qs'
    import {
        createLogger
    } from 'vuex';
    import debounce from '../../api/debounce';
    export default {
        data() {
            return {
                formdata: new FormData(),

                loadingBut: false,
                confirmTxt: 0,
                isorderAuditText: '',
                oerderDetilsShow: false,
                orderAuditShow: false,
                isorderAuditShow: false,
                returnReceiptShow: false,
                uobj: this.$store.state.uobj, //登陆缓存--用户信息
                date: [], //日期
                startTime: '',
                endTime: '',
                dateNowDayActive: false,
                dateYesterdayActive: false,
                dateNowMonthActive: false,
                dateLastMonthActive: false,
                twolevelUserLogin: true,
                timeIndex: 0, //判断第几次切换当月时间
                sameMonthTime: '', //目前月份
                currentMonthTime: '', //目前月份--上月+1
                tableData: [],
                ORMTB440CA00: '',
                materialOptions: [],
                materialTypeValue: '',
                oilList: [{
                    ORMTB473ID: '',
                    ORMTB473CA00: '全部',
                }],
                carNum: '',
                materielMo: '',
                materielOptions: [{
                    SETTB109CA00: '全部',
                    SETTB109ID: '',
                }],
                // 收支
                orOptions: [{
                    value: '',
                    label: '全部',
                }, {
                    value: '1',
                    label: '收入',
                }, {
                    value: '2',
                    label: '支出',
                }],

                incount: 0,
                expcount: 0,
                inprice: 0,
                expprice: 0,
                expcap: 0,
                // 查询
                ORMTB474CA00: '', //加油站
                ORMTB474CA02: '', //
                ORMTB474CA03: '', //
                ORMTB474CA05: '', //
                ORMTB474CA06: '', //
                ORMTB474CA11: '', //


                pageMo: 1, //默认列表页码
                limitMo: 10, //每页的条数
                pagingPageMo: 0, //分页--数据列表共有的条数
                currentPage: 1, //设置当前页默认为1
                // 详情
                detailsList: '', //详情列表
                tableHeadList: [

                    {
                        prop: 'ORMTB474CA02',
                        label: '核销人姓名',
                        
                    },
                    // {
                    //     prop: 'ORMTB474CA03',
                    //     label: '核销人手机号',

                    // },
                    {
                        prop: 'ORMTB474CA05',
                        label: '消费者姓名',
                        
                    },
                    {
                        prop: 'ORMTB474CA06',
                        label: '消费者手机号',

                    },
                    {
                        prop: 'ORMTB474CA07',
                        label: '时间',

                    },
                    // {
                    //     prop: 'ORMTB474CA08',
                    //     label: '单价',

                    // },
                    // {
                    //     prop: 'ORMTB474CA09',
                    //     label: '容量',

                    // },
                    {
                        prop: 'ORMTB474CA10',
                        label: '金额',

                    }

                ],

                isRefresh: true,
                // 历史缓存
                currentUrl: this.$route.path,
                historyInfo: '',
                // 时间限制
                // 限制开始日期不能超过当前日期
                startDateDisabled: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                solelist: [],
                DetailsWaterurl: '',
                DetailsWatersrcList: [],
                DetailsWeightrcList: [],
                DetailsWeightrcBDList:[],
                ewmDetails:[],
                materialList: [],
                materialValue: '',
                listTick: null, // 列表刷新定时器
                timeType: '1',
                distf:true,
                dcmoreID:'',
                dcmore:'',
            }
        },
        watch: {
            weightOpt: {
                handler(val) {
                    if ((val.tare || val.tare === 0) && (val.gross || val.gross === 0) && (val.price || val.price === 0)) {
                        let tare = parseFloat(val.tare)
                        let gross = parseFloat(val.gross)
                        this.detailsList.ORMTB440CC04 = (tare - gross).toFixed(2)
                        if (this.detailsList.ORMTB440CC04) {
                            debounce(this.getSettlementAmount, 500)
                        }
                    } else {
                        this.detailsList.ORMTB440CC04 = ''
                        this.detailsList.ORMTB440CC06 = ''
                    }
                },
                deep: true
            },
        },
        created() {
            var list = "";
            list = this.$store.state.solelist;
            // console.log(list)
            // 赋值，缓存销毁
            this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
            sessionStorage.removeItem(this.currentUrl)
            if (this.historyInfo != null && this.historyInfo != '') {
                this.init()
            }
            // console.log(this.historyInfo)
            // else {
            // 	this.getNowDay();
            // }
            var path = this.$route.path;
            if (path === '/oilCardBill') {
                path = '/Home' + path
            }
            this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表

            // console.log(this.solelist)
        },
        mounted() {
            if (this.historyInfo == null && this.$route.query.mark == null) {
                this.getNowDay();
                this.startTime = this.date[0];
                this.endTime = this.date[1];
                this.dateNowDayActive = true
            }

            this.fetchOilList()
            this.startListTimer()
            // console.log(this.$store.state.uobj)

			this.billData()
			this.pageList()
        },
        activated() {
          this.startListTimer()
        },
        deactivated() {
          this.stopListTimer()
        },
        // 存储数据
        beforeDestroy() {
          this.stopListTimer()
            clearInterval(this.listTick)
            this.listTick = null
            this.startTime = this.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.date[0]));
            this.endTime = this.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.date[1]));
            var obj = {
                startTime: this.startTime,
                endTime: this.endTime, //开始时间
                ORMTB440CA02: this.ORMTB440CA02, //客户id
                ORMTB400CA03: this.ORMTB400CA03, //客户名称
                ORMTB440CA04: this.ORMTB440CA04, //客户名称
                ORMTB440CA06: this.ORMTB440CA06, //二级企业id
                ORMTB440CA00: this.ORMTB440CA00, //数据状态--转换
                ORMTB440CA01: this.ORMTB440CA01, //数据状态--名字
                currentPage: this.currentPage, //当前页数
                pageMo: this.pageMo, //页码
                limitMo: this.limitMo, //每页条数
                dateNowDayActive: this.dateNowDayActive,
                dateYesterdayActive: this.dateYesterdayActive,
                dateNowMonthActive: this.dateNowMonthActive,
                dateLastMonthActive: this.dateLastMonthActive,
                ORMTB440CA00: this.ORMTB440CA00
            }
            sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
        },
        computed: {

        },
        methods: {

            startListTimer() {
              if (this.listTick) return
              this.listTick = setInterval(() => {
                if (document.hidden) return
                this.queryClick()
              }, 1000 * 60)
            },
            stopListTimer() {
              if (!this.listTick) return
              clearInterval(this.listTick)
              this.listTick = null
            },
            //初始化数据
            init() {
				console.log(this.historyInfo)
                this.startTime = this.historyInfo.startTime
                this.endTime = this.historyInfo.endTime
                this.date = [this.startTime, this.endTime]
                this.ORMTB440CA02 = this.historyInfo.ORMTB440CA02
                this.ORMTB400CA03 = this.historyInfo.ORMTB400CA03
                this.ORMTB440CA04 = this.historyInfo.ORMTB440CA04
                this.ORMTB440CA06 = this.historyInfo.ORMTB440CA06
                // this.ORMTB440CF01 = this.historyInfo.ORMTB440CF01
                this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
                this.ORMTB440CA01 = this.historyInfo.ORMTB440CA01
                this.currentPage = this.historyInfo.currentPage
                this.pageMo = this.historyInfo.pageMo
                this.limitMo = this.historyInfo.limitMo
                this.dateNowDayActive = this.historyInfo.dateNowDayActive
                this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
                this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
                this.dateLastMonthActive = this.historyInfo.dateLastMonthActive
                this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
            },
            // 导出
            exports() {

                var startTime = this.date[0]; //开始时间
                var endTime = this.date[1]; //结束时间

                var ORMTB474CA00=this.ORMTB474CA00;
                var ORMTB474CA02=this.ORMTB474CA02;
                var ORMTB474CA03=this.ORMTB474CA03;
                var ORMTB474CA05=this.ORMTB474CA05;
                var ORMTB474CA06=this.ORMTB474CA06;
                var ORMTB474CA11=this.ORMTB474CA11;


                var url = this.axios.defaults.baseURL + "/exc/toExcel/ormtb474toExcle?startTime=" + startTime +
                    "&endTime=" +
                    endTime + "&ORMTB474CA00=" + ORMTB474CA00 + "&ORMTB474CA02=" + ORMTB474CA02 +
                    "&ORMTB474CA03=" + ORMTB474CA03 + "&ORMTB474CA05=" + ORMTB474CA05 + "&ORMTB474CA06=" +
                    ORMTB474CA06 + "&ORMTB474CA11=" + ORMTB474CA11 ;
                window.location.href = url;

                this.loadingBut = true
                var timer = null //倒计时
                this.confirmTxt = 30 - 1
                timer = setInterval(() => {
                    if (this.confirmTxt === 0) {
                        this.confirmTxt = ""
                        this.loadingBut = false
                        clearInterval(timer);
                    } else {
                        this.confirmTxt--
                    }
                }, 1000);

            },


            // 取消订单
            cancelOrder(row) {
                var url = "/orm/ormtb440/updateORMTB440CF01";
                this.$prompt('请输入取消原因', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /^.{1,}$/,
                    inputErrorMessage: '原因不能为空'
                }).then(({
                             value
                         }) => {
                    var postData = {
                        ORMTB440ID: row.ORMTB440ID,
                        ORMTB440CF01: -1, //状态
                        ORMTB440CD01: value, //取消原因
                    }
                    let loading = this.$loading({
                        lock: true,
                        text: '请求中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.5)'
                    });
                    this.axios.post(url, postData).then(res => {
                        if (res.data.code == 200) {
                            this.pageList()
                            this.$message({
                                type: 'success',
                                message: '取消成功!'
                            });
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                        loading.close();
                    }).catch(() => {
                        loading.close();
                    })
                })
            },
            // ch
            fetchOilList() {
                var postData = {}
                var url = "/orm/ormtb473/selectAllList";
                var List = [{
                    ORMTB473ID: '',
                    ORMTB473CA00: '全部',
                }];
                this.axios.post(url, postData).then(res => {
                    if (res.data.code == 200) {
                        this.oilList = [...List, ...res.data.data];
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            // 查询
            queryClick() {
                this.startTime = this.date[0];
                this.endTime = this.date[1];
                this.pageList()
				this.billData();
            },
            // 列表
            pageList() {
                // var ORMTB400CA03
                // if (this.uobj.pertb005.pertb005cb00 == "CUS-2") {
                //     ORMTB400CA03 = this.uobj.ormtb410.ORMTB410ID
                // }
                // if (this.uobj.pertb005.pertb005cb00 == "CUS-1") {
                //     ORMTB400CA03 = this.uobj.ormtb400.ORMTB400CA03
                // }

                let loading = this.$loading({
                    lock: true,
                    text: '请求中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.5)'
                });
                var postData = {
                    startTime: this.startTime, //开始时间
                    endTime: this.endTime, //结束时间
                    ORMTB474CA00:this.ORMTB474CA00,
                    ORMTB474CA02:this.ORMTB474CA02,
                    ORMTB474CA03:this.ORMTB474CA03,
                    ORMTB474CA05:this.ORMTB474CA05,
                    ORMTB474CA06:this.ORMTB474CA06,
                    ORMTB474CA11:this.ORMTB474CA11,
                    page: this.pageMo,
                    limit: this.limitMo,
                    timeType: this.timeType
                }
                this.tableData = [];
                var url = "/orm/ormtb474/selectPageList";
                this.axios.post(url, postData).then(res => {
                    setTimeout(() => {
                        loading.close()
                    }, 400)
                    console.log(res)
                    if (res.data.code == 200) {
                        var data = res.data.data.list;
                        this.pagingPageMo = res.data.data.total;
                        for (var i = 0; i < data.length; i++) {
                            var customerName = "";
                        }
                        this.tableData = data;

                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                }).catch(() => {
                    loading.close();
                })
            },
            // 详情
            DetailsClick(row) {
                this.oerderDetilsShow = true;
                this.querydetile(row)
            },
            orderAudit(row) {
                this.orderAuditShow = true
                this.querydetile(row)
            },
            isorderAudit(row) {
                this.isorderAuditShow = true
                this.querydetile(row)
            },
            returnReceipt(row) {
                this.returnReceiptShow = true
                this.querydetile(row)
            },
            // 完成订单
            billData() {
                var postData = {
                    startTime: this.startTime, //开始时间
                    endTime: this.endTime, //结束时间
                    ORMTB474CA00:this.ORMTB474CA00,
                    ORMTB474CA02:this.ORMTB474CA02,
                    ORMTB474CA03:this.ORMTB474CA03,
                    ORMTB474CA05:this.ORMTB474CA05,
                    ORMTB474CA06:this.ORMTB474CA06,
                    ORMTB474CA11:this.ORMTB474CA11,
                    page: this.pageMo,
                    limit: this.limitMo,
                    timeType: this.timeType
                }

                var url = "/orm/ormtb474/billData";
                this.axios.post(url, postData).then(res => {
                    if (res.data.code == 200) {
                        this.incount = res.data.data.incount
                        this.expcount = res.data.data.expcount
                        this.inprice = res.data.data.inprice
                        this.expprice = res.data.data.expprice
                        this.expcap = res.data.data.expcap
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })

            },
            // 完成订单
            pushMsg(row){
                var postData = {
                    ORMTB440ID: row.ORMTB440ID, //流水id
                }
                var url = "/orm/ormtb440/sendMsg";
                this.$confirm('此操作将推送支付消息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios.post(url, postData).then(res => {
                        // console.log(res)
                        if (res.data.code == 200) {
                            this.pageList()
                            this.$message({
                                type: 'success',
                                message: '操作成功!'
                            });
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                })
            },
            completeClick(row) {
                var postData = {
                    ORMTB440ID: row.ORMTB440ID, //流水id
                }
                var url = "/orm/ormtb440/updatePayStatus";
                this.$confirm('此操作将完成该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios.post(url, postData).then(res => {
                        // console.log(res)
                        if (res.data.code == 200) {
                            this.pageList()
                            this.$message({
                                type: 'success',
                                message: '操作成功!'
                            });
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                })
            },
            orderAuditServe(type) {
                let loading = this.$loading({
                    lock: true,
                    text: '请求中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.5)'
                });
                var postData = {
                    ORMTB440CG00: type,
                    ORMTB440CG02: this.uobj.pertb005.pertb005ca02,
                    ORMTB440ID: this.detailsList.ORMTB440ID,
                    ORMTB440CA02: this.detailsList.ORMTB440CA02,
                    ORMTB440CA11: this.detailsList.ORMTB440CA11,
                    ORMTB440CA12: this.detailsList.ORMTB440CA12,
                }
                this.tableData = [];
                var url = "/orm/ormtb440/updateORMTB440CG00";
                this.axios.post(url, postData).then(res => {
                    setTimeout(() => {
                        loading.close()
                    }, 400)
                    if (res.data.code == 200) {
                        this.$message({
                            message: '审核成功',
                            type: 'success'
                        });
                        this.orderAuditShow = false
                        this.pageList()
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                }).catch(() => {
                    loading.close();
                })
            },
            querydetile(row) {
                var postData = {
                    ORMTB440ID: row.ORMTB440ID, //流水id
                }
                this.detailsList = ''
                var url = "/orm/ormtb440/selectDetails";
                this.axios.post(url, postData).then(res => {
                    if (res.data.code == 200) {
                        this.detailsList = res.data.data;
                        this.DetailsWatersrcList = [this.detailsList.ORMTB440CE01]
                        if (this.detailsList.ORMTB440CH05) this.DetailsWeightrcList = [this.detailsList
                            .ORMTB440CH05
                        ]
                        if (this.detailsList.ORMTB440CL01) this.DetailsWeightrcBDList = [this.detailsList
                            .ORMTB440CL01
                        ]
                        this.DetailsWaterurl = this.detailsList.ORMTB440CE01
                        if (this.detailsList.ORMTB440CF01 == 6 || (row.ORMTB440CF01 == 0 && row.ORMTB440CA22)) {
                            this.weightOpt.price = this.detailsList.ORMTB440CC03
                            if (this.detailsList.ORMTB440CC06 == 0) this.detailsList.ORMTB440CC06 = ''
                            this.weightOpt.tare = this.detailsList.ORMTB440CC05
                            this.weightOpt.gross = (this.detailsList.ORMTB440CC05 - this.detailsList.ORMTB440CC04)
                                .toFixed(2)
                            this.getSelectMaterial()
                        }
                        // else if (this.detailsList.ORMTB440CF01 == 0) {
                        // 	this.weightOpt.price = this.detailsList.ORMTB440CC03
                        // 	this.getSelectMaterial()
                        // }

                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }

                })
            },
            queryermdetile(row) {
                var postData = {
                    ORMTB440ID: row.ORMTB440ID, //流水id
                }
                this.detailsList = ''
                var url = "/orm/ormtb440/getErwei";
                this.axios.post(url, postData).then(res => {
                    if (res.data.code == 200) {
                        this.ewmdetailsList = res.data.data;
                        this.ewmdetailsList.ORMTB440CA22Img = 'data:image/png;base64,' + res.data.data.ORMTB440CA22;

                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }

                })
            },

            dateFtt(fmt, date) { //author: meizz
                var o = {
                    "M+": date.getMonth() + 1, //月份
                    "d+": date.getDate(), //日
                    "h+": date.getHours(), //小时
                    "m+": date.getMinutes(), //分
                    "s+": date.getSeconds(), //秒
                    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
                    "S": date.getMilliseconds() //毫秒
                };
                if (/(y+)/.test(fmt))
                    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
                for (var k in o)
                    if (new RegExp("(" + k + ")").test(fmt))
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
                            .length)));
                return fmt;
            },

            //获取当前时间
            getNowDay() {
                var date = new Date().getTime();
                var Ming = new Date().getTime() + 24 * 60 * 60 * 1000;
                var data = this.dateFtt('yyyy-MM-dd', new Date(Ming))
                var enddata = this.dateFtt('yyyy-MM-dd', new Date(date))
                data = `${data} ${this.exchangeTiem||'00:00:00'}`
                enddata = `${enddata} ${this.exchangeTiem||'00:00:00'}`
                this.date = [enddata, data];
                this.dateNowDayActive = true
                this.dateYesterdayActive = false
                this.dateNowMonthActive = false
                this.dateLastMonthActive = false
            },
            datePickerChange(e) {
                this.dateNowDayActive = false
                this.dateYesterdayActive = false
                this.dateNowMonthActive = false
                this.dateLastMonthActive = false
            },
            //获取昨天时间
            getYesterday() {
                var hms = new Date().getTime() - 24 * 60 * 60 * 1000;
                var Ming = new Date().getTime();
                var nowDay = this.dateFtt('yyyy-MM-dd', new Date(hms))
                var enddata = this.dateFtt('yyyy-MM-dd', new Date(Ming))
                nowDay = `${nowDay} ${this.exchangeTiem||'00:00:00'}`
                enddata = `${enddata} ${this.exchangeTiem||'00:00:00'}`
                this.date = [nowDay, enddata];
                this.dateNowDayActive = false
                this.dateYesterdayActive = true
                this.dateNowMonthActive = false
                this.dateLastMonthActive = false
            },
            //获取当月时间
            sameMonth() {
                var date = new Date();
                var hms = date.setDate(1);
                var firstDay = this.dateFtt('yyyy-MM-dd', new Date(hms));
                firstDay = `${firstDay} ${this.exchangeTiem||'00:00:00'}`
                var nextdate = new Date().getTime() + 24 * 60 * 60 * 1000;
                var nextDay = this.dateFtt('yyyy-MM-dd', new Date(nextdate));
                nextDay = `${nextDay} ${this.exchangeTiem||'00:00:00'}`
                this.date = [firstDay, nextDay];
                this.startTime = this.date[0];
                this.endTime = this.date[1];
                this.dateNowDayActive = false
                this.dateYesterdayActive = false
                this.dateNowMonthActive = true
                this.dateLastMonthActive = false
            },
            //获取上月时间
            lastMonth() {
                var nowdays = new Date();
                var year = nowdays.getFullYear();
                var month = nowdays.getMonth();
                var lastyear = year
                var lastmonth = month
                if (month == 0) {
                    month = 12;
                    year = year - 1;
                }
                if (month == 12) {
                    lastmonth = 1
                } else {
                    lastmonth = lastmonth + (1 * 1)
                }
                if (month < 10) {
                    month = "0" + month;
                }
                if (lastmonth < 10) {
                    lastmonth = "0" + lastmonth;
                }
                var firstDayOfPreMonth = year + "-" + month + "-" + "01";
                var firstDayOfPreMonth = `${year}-${month}-01 ${this.exchangeTiem||'00:00:00'}`;
                // var lastDay = new Date(lastyear, lastmonth, 0);
                let lastDayOfPreMonth = `${lastyear}-${lastmonth}-01 ${this.exchangeTiem||'00:00:00'}`;
                this.date = [firstDayOfPreMonth, lastDayOfPreMonth];
                this.dateNowDayActive = false
                this.dateYesterdayActive = false
                this.dateNowMonthActive = false
                this.dateLastMonthActive = true
            },
            handleSizeChange(val) {
                this.pageMo = 1
                this.limitMo = val;
                this.pageList();
            },
            // 点击页码
            handleCurrentChange(val) {
                this.pageMo = val;
                this.pageList();
            },
        }
    }
</script>

<style scoped>

	.DWD-li {
		display: flex;
		height: 35px;
		line-height: 35px;
		box-sizing: border-box;
		border: 1px solid #999;
		font-size: 16px;
		color: #333;
	}

	.DWD-li>div {
		padding: 0 5px;
		height: 34px;
		overflow: hidden;
		box-sizing: border-box;
	}

	.DWD-li-title {
		width: 120px;
		text-align: center;
		border-right: 1px solid #999;
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-li-text {
		flex: 1;
	}

	.DWD-li-text input {
		width: 100%;
		height: 35px;
		line-height: 35px;
		border: none;
		outline: none;
	}

	.DWD-li+.DWD-li {
		border-top: none;
	}

	.DWD-table {
		display: flex;
	}

	.DWD-table-left-flex {
		flex: 1;
	}

	.DWD-table>div>div {
		padding: 0 5px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		text-align: center;
		border-right: 1px solid #999;
		border-bottom: 1px solid #999;
		box-sizing: border-box;
	}

	.DWD-table>div>div:first-child {
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-table-left-title>div {
		width: 101px;
		text-align: center;
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-table .DWD-table-left-title>div {
		padding: 0 5px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		box-sizing: border-box;
		border-left: 1px solid #999;
		border-bottom: 1px solid #999;
	}

	.DetailsWater-img {
		margin-top: 30px;
	}

	.DetailsWater-img-text {
		display: inline-block;
		width: 101px;
		text-align: center;
		vertical-align: top;
	}

	.car-number-add {
		/* text-transform: uppercase; */
	}

	.billOperationRecord-table {
		padding: 30px 20px 0;
	}

	.public_singleMenu .pulic_carNumber {
		margin-top: 6px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		font-size: 14px;
		display: inline-block;
	}

	.pulic_operatArea_now:hover,
	.public_operatArea_yesterday:hover {
		background-color: #ccc;
	}

	/* 新增--列表宽度 */
	.billOperationRecord .systemCodePC-add-code-table-li-ipt {
		flex: 1.5;
	}

	.fontBlue {
		color: rgba(25, 159, 255, 1) !important;
	}

	.public_oparetionBlock_Menu .pulic_carNumber {
		margin-top: 6px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		font-size: 14px;
		display: inline-block;
	}

	.billOperationRecord .public_oparetionBlock_Menu {
		height: 45px;
		align-items: center;
	}

	.billOperationRecord {
		background-color: #f3f3f3;
	}

	.billOperationRecord th,
	.billOperationRecord td {
		text-align: center !important;
	}

	/* 统计 START*/
	.imgStatistics {
		width: 40px;
		height: 40px;
	}

	.payType {
		font-size: 20px;
		/* font-size: 24px; */
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(102, 102, 102, 1);
		line-height: 26px;
	}

	.singular {
		font-size: 32px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(51, 51, 51, 1);
		line-height: 30px;
		vertical-align: middle;
		padding-left: 10px;
	}

	.Amount {
		font-size: 32px;
		font-family: Microsoft YaHei;
		/* font-weight:bold; */
		line-height: 30px;
		vertical-align: middle;
		padding-left: 10px;
	}

	.pulic_statistics_titlt {
		line-height: 40px;
	}

	.Customer-upload-bd {
		padding: 20px 0;
	}

	.disabled {
	.el-upload--picture-card {
		display: none;
	}
	}

    .public_lbSty {
		width: 100px;
    }

	/* 统计 END*/
</style>
